export default __webpack_public_path__ + "static/media/Inicio_session.6b29c729.png";